import {
  FlexBoxImageScaleView,
  FlexBoxView,
  getFlexNode,
} from '@play-co/timestep-core/flexbox';
import { View } from '@play-co/timestep-core/ui';
import { Avatar } from 'src/game/components/shared/Avatar';
import LangBitmapFontTextView, {
  LangBitmapOpts,
} from 'src/lib/ui/components/LangBitmapFontTextView';
import type { UserProfileDetails } from 'src/replicant/friends/friends.asyncGetters';

const assets = {
  background: 'assets/ui/shared/frames/scroller_panel_blue.png',
};

export class UnfriendPlayerInfoPanel extends FlexBoxImageScaleView {
  private avatar: Avatar;
  private nameLabel: LangBitmapFontTextView;
  private petNameLabel: LangBitmapFontTextView;

  public static get assets() {
    return Object.values(assets);
  }

  constructor(superview: View) {
    super({
      superview,
      image: assets.background,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 19, right: 22 },
        vertical: { top: 19, bottom: 28 },
      },
      flex: {
        width: 526,
        height: 170,
      },
    });

    const wrapper = new FlexBoxView({
      superview: this,
      flex: {
        width: '100%',
        height: '100%',
        paddingHorizontal: 15,
        paddingBottom: 4,
        alignItems: 'center',
      },
    });

    // Create avatar
    this.avatar = new Avatar({
      superview: wrapper,
      width: 128,
      height: 128,
      centerOnOrigin: false,
    });

    // Create content column container
    const contentColumn = new FlexBoxView({
      superview: wrapper,
      flex: {
        flexDirection: 'column',
        flexGrow: 1,
        marginLeft: 25,
      },
    });

    const baseLabelOpts: LangBitmapOpts = {
      font: 'Body',
      color: '#9A7171',
      verticalAlign: 'center',
    };

    // Create name label
    this.nameLabel = new LangBitmapFontTextView({
      superview: contentColumn,
      ...baseLabelOpts,
      size: 36,
      height: 48,
    });
    getFlexNode(this.nameLabel).flexGrow = 1;

    // Create pet name label
    this.petNameLabel = new LangBitmapFontTextView({
      superview: contentColumn,
      ...baseLabelOpts,
      size: 28,
      height: 35,
    });
    getFlexNode(this.petNameLabel).flexGrow = 1;
  }

  public setData(data: UserProfileDetails) {
    this.avatar.updateImage(data.photo);
    this.avatar.setFrame(data.frame);
    this.nameLabel.localeText = () => data.name;
    this.petNameLabel.localeText = () => data.attributes.name;
  }
}
